<div class="has-pos-rel" #searchBarRef>
    <div class="search-bar-container is-flex">
      <div class="flex-one"  [class.no-search-results]="!showSearchResults">
        <form [formGroup]="searchForm">
          <app-input [focus]="focus" (onFocus)="onSearchInputClick()" (onBlur)="onLoseFocus()"
                     [parentFormGroup]="searchForm" [formControl]="searchForm.controls['searchInput']"
                     [placeholder]="placeholder"
                     [ariaTranslateTag]="'searchBar.aria.' + ('inputPlaceholder')">
          </app-input>
        </form>
      </div>
    </div>
  
    <div [class.hidden]="!showSearchResults">
      <app-search-results *ngIf="showSearchResults"
                          [locationResults]="locationResults"
                          (onBlur)="onLoseFocus()"
                          (selectResult)="onSelectResult($event)"
                          [isSearchingForResults]="isSearching"
                          [searchInput]="searchInput"
                          [showButtons]="showAdditionalActionsButtons">
      </app-search-results>
    </div>
  </div>